import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Col, Row, Button } from 'reactstrap';
import * as createCaseActions from '../actions'
/* import StringConst from '../../../StringConst';
import { COUNTER_PARTY_LABEL } from '../../constants'; */
import { goolgeAnalyticsEvents } from '../../../../components/GoogleAnalytics/index';
import { DOMESTIC, INTERNATIONAL, INDIA_OBJECT } from '../../constants';
import { checkGeographicType, createRequestBody } from './helper';
import { toast } from 'react-toastify';
import MyAutosuggest from '../../../../components/ReusableComponents/AutoSuggest/index';
const required = value => value ? null : 'Required';
const validCheck = value => !value||value.match(/^[^<>!$%^?*~`{}=]*$/) ? null :'Please enter valid Input';

const renderField = ({ input, label, type, isRequired, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)

class AddCounterPartyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            option: "",
            selectedCountry: '',
            selectedState: ''
        };
    }

    componentDidMount = () => {
        this.props.getIndianstatesList();
        if (this.props.caseType === DOMESTIC) {
            this.props.change('geographicType', DOMESTIC)
            this.props.change('country', INDIA_OBJECT);
            this.setState({
                selectedCountry: INDIA_OBJECT
            })
        } else if (this.props.caseType === INTERNATIONAL) {
            this.props.change('geographicType', INTERNATIONAL)
            this.props.change('country', '')
            this.setState({
                selectedCountry: ''
            })
        }
    }
    handleCancel = () => {
        this.props.closeModal()
    }
    mySubmitCounterparty = (val) => {
        if (this.props.createCounterpartyRequestType === 'Corporate') {
            goolgeAnalyticsEvents('Corporate', 'Create Counterparty Request From Corporate', 'Create Counterparty', '');
        }
        let tempGeographicType = checkGeographicType(this.props.counterpartyFormValues)
        let tempRequestBody = null;
        if (!tempGeographicType) {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Choose Counterparty Country
                </div>
            );
        }else if(this.state.selectedState === "" && val.geographicType=="DOMESTIC"){
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Choose Counterparty State
                </div>
            );
        }        
        else {
            tempRequestBody = createRequestBody(val, tempGeographicType)
            this.props.createCounterparty(tempRequestBody)
            this.props.closeModal()
        }/* else if (tempGeographicType === DOMESTIC) {
            
        } else if (tempGeographicType === INTERNATIONAL) {
            tempRequestBody = createRequestBody(val, tempGeographicType)
            this.props.createCounterparty(tempRequestBody)
            this.props.closeModal()
        } */
    }

    handleCounterpartyGeographicChange = (event) => {
        if (event.target.value === DOMESTIC) {
            this.props.change('country', INDIA_OBJECT)
        } else {
            this.props.change('country', '')
        }
    }
    searchCallback = (selected, type) => {
        if (type === 'countrySearch') {
            this.setState({
                selectedCountry: selected
            })
            this.props.change('country', selected)
            if (this.props.caseType === undefined) {
                if (selected.value === INDIA_OBJECT.value) {
                    this.props.change('geographicType', DOMESTIC)
                } else if (selected.value !== "" && selected.value !== INDIA_OBJECT.value) {
                    this.props.change('geographicType', INTERNATIONAL)
                }
            }
        } else {
            this.setState({
                selectedState: selected
            })
            this.props.change('state', selected)
        }
    }
    resetForm = () => {
        this.setState({
            selectedCountry: '',
            selectedState: ''
        })
        this.props.reset()
    }
    render() {
        const { handleSubmit, pristine, reset, submitting, statesList, closeModal, caseType } = this.props
        const { value } = this.state;
        let cancelButton;
        let tempGeographicType = checkGeographicType(this.props.counterpartyFormValues);
        let inputPropsState = {
            placeholder: "Search State",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        }
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            disabled: (caseType === DOMESTIC) ? true : false,
            className: "form-control"
        };
        if (closeModal) {
            cancelButton =
                <Button color="secondary" onClick={this.handleCancel}>
                    Cancel
                </Button>
        }
        return (
            <form className="modal-content shadow-none border-0" onSubmit={handleSubmit((val) => {
                this.mySubmitCounterparty(val)
            })}>
                <div className="modal-header row pt-0">
                    <h5 className="mb-0">Add Counterparty</h5>
                    <button type="button" onClick={this.handleCancel} className="close outline-none" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {/* <div>
                        <label>Counterparty Geographic Type<i className='text-danger'>*</i></label>
                        <label style={{ marginLeft: '2%' }}>
                            <Field name="geographicType" component="input" checked={(this.props.caseType === DOMESTIC) ? true : false} type="radio" value={DOMESTIC} onChange={this.handleCounterpartyGeographicChange} />{' '}
                            Domestic
                            <Field name="geographicType" component="input" checked={(this.props.caseType === INTERNATIONAL) ? true : false} type="radio" value={INTERNATIONAL} onChange={this.handleCounterpartyGeographicChange} />{' '}
                            International
                        </label>
                    </div> */}
                    <Field
                        name="counterpartyName"
                        type="text"
                        component={renderField}
                        label="Counterparty Name"
                        isRequired={true}
                        validate={[required,validCheck]} />
                    <Field
                        name="address"
                        type="text"
                        component={renderField}
                        label="Counterparty Address"
                        isRequired={true}
                        validate={[required,validCheck]} />
                    <Row className="mb-4">
                        <div className="col-9">
                            <label>Country</label>
                            <span className="text-danger">*</span>
                        </div>

                        <div className="col-15 pl-4">
                            <MyAutosuggest
                                id='countrySearch'
                                placeholder="Search Country"
                                onChange={this.handleCountryAutocomplete}
                                searchCallback={this.searchCallback}
                                inputProps={inputProps}
                                searchType="countrySearch"
                                selectedValueCountry={this.state.selectedCountry} />
                            {/* <Field
                                name="country"
                                type="text"
                                component={countryDropdown}
                                label="Country"
                                isRequired={true}
                                data={COUNTRY}
                                dis={(!tempGeographicType || tempGeographicType === DOMESTIC) ? true : false}
                                validate={[required]} /> */}
                        </div>
                    </Row>
                    <Row className="mb-4">
                        <div className="col-9">
                            <label>State</label>
                           { (!tempGeographicType || tempGeographicType === DOMESTIC) ?
                            <span className="text-danger">*</span>:null
                            }                            
                        </div>
                        <div className="col-15 pl-4">
                            <MyAutosuggest
                                id='stateSearch'
                                placeholder="Search State"
                                onChange={this.handleCountryAutocomplete}
                                searchCallback={this.searchCallback}
                                inputProps={inputPropsState}
                                selectedValueState={this.state.selectedState}
                                countryValue={this.state.selectedCountry.id}
                                searchType="stateSearch" />
                        </div>
                    </Row>
                    <Field
                        name="city"
                        type="text"
                        component={renderField}
                        validate={[validCheck]}
                        label="City" />
                    {
                        (!tempGeographicType || tempGeographicType === DOMESTIC) ?
                            <div>
                                <Field
                                    name="pinCode"
                                    type="text"
                                    component={renderField}
                                   validate={[validCheck]}
                                    label="Pin code"
                                    />
                                <Field
                                    name="gstNo"
                                    type="text"
                                    component={renderField}
                                    validate={[validCheck]}
                                    label="Counterparty GST No."
                                />
                                <Field
                                    name="panNo"
                                    type="text"
                                    component={renderField}
                                    validate={[validCheck]}
                                    label="Counterparty PAN No."
                                />
                                <Field
                                    name="cinNumber"
                                    type="text"
                                    component={renderField}
                                    validate={[validCheck]}
                                    label="Counterparty CIN No."
                                />
                                </div> : null}
                    <Field
                        name="contactNumber"
                        type="text"
                        component={renderField}
                        validate={[validCheck]}
                        label="Contact Details" />
                </div>
                <div className="modal-footer row pb-0">
                    {cancelButton}
                    <Button color="secondary" disabled={pristine || submitting} onClick={this.resetForm}>Clear</Button>
                    <Button type="submit" color="primary" disabled={pristine || submitting}>Submit</Button>
                </div>
            </form>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    modal: state.createCase.modal,
    GSTNo: state.createCase.GSTNo,
    selectedCounterparty: state.createCase.selectedCounterparty,
    statesList: state.createCase.statesList,
    counterpartyFormValues: state.form.AddCounterPartyForm
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    createCounterparty: (counterparty) => {
        dispatch(createCaseActions.createCounterparty(counterparty));
    },
    getIndianstatesList: () => {
        dispatch(createCaseActions.getIndianStates());
    },
})

export default reduxForm({
    form: 'AddCounterPartyForm'
})(connect(mapStateToProps, mapDispatchToProps)(AddCounterPartyForm))
